import { render, staticRenderFns } from "./MyCartFooter.vue?vue&type=template&id=af966f66&scoped=true&"
import script from "./MyCartFooter.vue?vue&type=script&lang=js&"
export * from "./MyCartFooter.vue?vue&type=script&lang=js&"
import style0 from "./MyCartFooter.vue?vue&type=style&index=0&id=af966f66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af966f66",
  null
  
)

export default component.exports